import config from "./config";

// 镜像详情列表查询
function queryImageInfoApi(params) {
    return Ajax.get(config.queryImageInfo, params);
}


export { 
	queryImageInfoApi,
};



// WEBPACK FOOTER //
// ./src/api/mirror/detail/actions.js